import * as React from 'react';

import { ChatPlugin, EmojiReaction } from '@common/react/components/Chat/Chat';
import ChatReactionComponent from '@common/react/components/Chat/Reactions/ChatReactionComponent';
import { NotificationAction } from '@common/typescript/objects/NotificationAction';
import loadable from '@common/react/loadable/loadableSettings';

const TextChatMessage = loadable(() =>
	import(/* webpackChunkName: "TextChatMessage" */ '@common/react/components/Chat/TextChatMessage'));

export const ReactionsPlugin: ChatPlugin = {
	message: {
		render: () => null,
		notification: ({ message }) => {
			return (
				<div style={{
					display: 'flex',
					alignItems: 'center',
				}}
				>
					<span style={{ marginRight: '10px' }}>has left reaction</span>
					{message.reaction && <TextChatMessage
						className="reaction-emoji"
						emojiSize={22}
						text={message.reaction}
						contacts={[]}
					/>}
				</div>
			);
		},
	},
	chatMessageAction: ({ message }) =>
		<ChatReactionComponent message={message} />,
	notificationHandler: (notification, storageName, actions, options) => {
		if (notification.objectType === options?.objectType) {
			const chatReaction = notification.data as EmojiReaction;
			if (notification.action === NotificationAction.Add) {
				actions.addReaction(chatReaction.object.chatId, chatReaction.objectId, {
					...chatReaction,
					animate: true,
				}, storageName);
			} else {
				actions.removeReaction(chatReaction.object.chatId, chatReaction.objectId, chatReaction.id, storageName);
			}
		}
	},
	options: {
		objectType: 'ChatEmojiReaction',
	},
};
